export const capitalizeFirstLetter = (text: string) => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const extractTextAndTruncate = (html: string, charactersLimit = 300): string => {
    // Create a new DOM element and set its innerHTML to the provided HTML string
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Extract the text content from the element
    let textContent = tempDiv.textContent || tempDiv.innerText || "";

    // Truncate the text content to character and add ellipses if necessary
    return textContent.length > charactersLimit
        ? `${textContent.substring(0, charactersLimit)}...`
        : textContent;
};


const stringifiedArrayToLines = (text: string) => {
  try {
    return JSON.parse(text).join("\n") 
  } catch (error) {
    return ""
  }
}

const commaCapitalSplitToLines = (input: string): string => {
  const items = input
    .trim()
    .split(/, (?=[A-ZÁÀÉÍÓÚÂÊÃ])/) // splits on the pattern: ", UpperCaseLetter"
    .map(item =>
      item.trim()).join("\n")
  return items
}

export const normalizeFormCheckboxAnswer = (input: string): string => {
  if (!input) return ""
  return stringifiedArrayToLines(input) || commaCapitalSplitToLines(input)
}

